import { render, staticRenderFns } from "./ScreensaverInfo.vue?vue&type=template&id=6f8f66ab&"
import script from "./ScreensaverInfo.vue?vue&type=script&lang=ts&"
export * from "./ScreensaverInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ScreensaverInfo.vue?vue&type=style&index=0&id=6f8f66ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports